(() => {
  if (window.tpContactStackReady) return;
  window.tpContactStackReady = true;
  let pending = false;
  let observedChat;
  let observedRuntime;
  let observedWrapper;
  let observedActivator;
  let observedNudge;
  let hiddenWrapper;
  let originalAriaHidden;
  let originalInert;
  const gap = 16;
  const edge = 12;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  const shadowObserver = new MutationObserver(schedule);
  const runtimeObserver = new MutationObserver(schedule);
  const wrapperObserver = new MutationObserver(schedule);
  const resizeObserver = new ResizeObserver(schedule);
  const setPosition = (wrapper, property, value) => {
    if (wrapper.style.getPropertyValue(property) !== value) wrapper.style.setProperty(property, value);
  };
  const setHidden = (wrapper, hidden) => {
    if (hidden) {
      if (hiddenWrapper !== wrapper) {
        hiddenWrapper = wrapper;
        originalAriaHidden = wrapper.getAttribute('aria-hidden');
        originalInert = wrapper.inert;
      }
      if (!wrapper.hasAttribute('data-tp-contact-hidden')) wrapper.setAttribute('data-tp-contact-hidden', '');
      if (wrapper.getAttribute('aria-hidden') !== 'true') wrapper.setAttribute('aria-hidden', 'true');
      if (!wrapper.inert) wrapper.inert = true;
    } else if (hiddenWrapper === wrapper) {
      wrapper.removeAttribute('data-tp-contact-hidden');
      if (originalAriaHidden === null) wrapper.removeAttribute('aria-hidden');
      else wrapper.setAttribute('aria-hidden', originalAriaHidden);
      wrapper.inert = originalInert;
      hiddenWrapper = undefined;
    }
  };
  const update = () => {
    pending = false;
    const wrapper = document.getElementById('wfb-wrapper');
    const chat = document.querySelector('shopify-chat');
    const shadow = chat?.shadowRoot;
    if (shadow && observedChat !== shadow) {
      shadowObserver.disconnect();
      shadowObserver.observe(shadow, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','class','style','hidden','open','shell-ready']});
      observedChat = shadow;
    }
    const runtime = shadow?.querySelector('shopify-agent-runtime');
    const runtimeShadow = runtime?.shadowRoot;
    if (observedRuntime !== runtimeShadow) {
      runtimeObserver.disconnect();
      if (runtimeShadow) runtimeObserver.observe(runtimeShadow, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','class','style','hidden','open','inert']});
      observedRuntime = runtimeShadow;
    }
    if (!wrapper) return;
    if (observedWrapper !== wrapper) {
      wrapperObserver.disconnect();
      wrapperObserver.observe(wrapper, {attributes:true,attributeFilter:['style','class']});
      observedWrapper = wrapper;
    }
    const activator = runtimeShadow?.querySelector('button[part~="activator"]') || shadow?.querySelector('button[part~="activator"]');
    const nudge = activator?.closest('.activator-nudge');
    if (observedActivator !== activator || observedNudge !== nudge) {
      resizeObserver.disconnect();
      resizeObserver.observe(wrapper);
      if (activator) resizeObserver.observe(activator);
      if (nudge) resizeObserver.observe(nudge);
      observedActivator = activator;
      observedNudge = nudge;
    }
    if (activator?.getAttribute('aria-expanded') === 'true' || runtime?.hasAttribute('open')) {
      setHidden(wrapper, true);
      return;
    }
    const rect = activator?.getBoundingClientRect();
    if (!rect || rect.width === 0 || rect.height === 0) {
      setPosition(wrapper, '--tp-contact-right', 'max(20px,env(safe-area-inset-right))');
      setPosition(wrapper, '--tp-contact-bottom', 'calc(100px + env(safe-area-inset-bottom))');
      setHidden(wrapper, false);
      return;
    }
    const nudgeRect = nudge?.getBoundingClientRect();
    const top = nudgeRect?.height > 0 ? Math.min(rect.top, nudgeRect.top) : rect.top;
    const bottom = Math.ceil(window.innerHeight - top + gap);
    const right = Math.max(edge, Math.round(window.innerWidth - rect.right));
    const button = wrapper.querySelector('[data-platform="whatsapp"]');
    const height = Math.max(56, button?.getBoundingClientRect().height || wrapper.getBoundingClientRect().height);
    setPosition(wrapper, '--tp-contact-right', `${right}px`);
    setPosition(wrapper, '--tp-contact-bottom', `${bottom}px`);
    setHidden(wrapper, bottom + height > window.innerHeight - edge);
  };
  const start = () => {
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.visualViewport?.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    let attempts = 0;
    const timer = window.setInterval(() => {
      schedule();
      if ((observedChat && observedWrapper) || ++attempts >= 60) window.clearInterval(timer);
    }, 500);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
